import { render, staticRenderFns } from "./DispatcherEvents.vue?vue&type=template&id=449c91b8&scoped=true&"
import script from "./DispatcherEvents.vue?vue&type=script&lang=js&"
export * from "./DispatcherEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449c91b8",
  null
  
)

export default component.exports